export const getCsrfToken = (): string => {
    const meta = document.querySelector('meta[name="_csrf"]');
    return meta ? meta.getAttribute('content') || '' : '';
};